import Skeleton from 'src/components/Skeleton';
import styles from './MenuItemCardSkeleton.module.scss';

const MenuItemCardSkeleton = () => (
  <div className={styles['card']} data-testid="menu-item-card-skeleton">
    <Skeleton variant="rectangular" width={200} height={92} />
    <div className={styles['label']}>
      <Skeleton variant="text" width="80%" height={20} />
      <Skeleton variant="text" width="60%" height={16} />
    </div>
  </div>
);

export default MenuItemCardSkeleton;
